import { Component, computed, HostListener, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Eventstatus } from '../../eventstatus';
import { EventconfigStoreService } from '../../eventconfig-store.service';
import { PlayerStoreService } from '../../player-store.service';
import { UserAssignService } from '../../user-assign.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'lse-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit, OnDestroy {
  private es = inject(EventconfigStoreService);
  private vs = inject(PlayerStoreService);
  private us = inject(UserAssignService);

  readonly activeLang = this.es.activeLang;
  readonly eLangGlob = computed(() => this.es.getLangGlobals());

  screenwidth = document.body.offsetWidth;
  eStatus: Eventstatus | null = null;
  eStream = '';
  debugAssignServer = 'ext';
  serverDisplay = '';
  environmentVars = environment;
  mailSubjectServer = '';

  private statusSub!: Subscription;

  ngOnInit(): void {
    this.debugAssignServer = this.us.getSuccessServer() || 'ext';

    this.statusSub = this.es.status$.subscribe((status) => {
      if (!status) return;
      this.eStatus = status;

      this.eStream = this.vs.getPlayerSrc() || '';
      if (this.eStream) {
        this.serverDisplay = this.eStream;
        if (this.serverDisplay.includes('playout')) {
          this.serverDisplay = 'Server: ' + this.serverDisplay.substring(8, 15);
        } else if (this.serverDisplay.includes('ssl.dev.rwe.com')) {
          this.serverDisplay = 'Server: ' + this.serverDisplay.substring(8, 16);
        } else if (this.serverDisplay.includes('wow-901.video-archiv.info')) {
          this.serverDisplay = 'Server: wow-901';
        } else if (this.serverDisplay.includes('wow-01.video-archiv.info')) {
          this.serverDisplay = 'Server: Extern';
        } else if (this.serverDisplay.includes('wow-02.video-archiv.info')) {
          this.serverDisplay = 'Server: Extern';
        } else if (this.serverDisplay.includes('wow-03.video-archiv.info')) {
          this.serverDisplay = 'Server: Extern';
        } else if (this.serverDisplay.includes('akamai')) {
          this.serverDisplay = 'Server: Cloud A';
        } else if (this.serverDisplay.includes('cdn3.wowza')) {
          this.serverDisplay = 'Server: Cloud';
        }
        this.mailSubjectServer = ' - ' + this.serverDisplay;
      }
    });
  }

  /*
   * Optionaler Text & Link aus der Live-Steuerung im CCP, in der aktiven Sprache. Als Getter,
   * damit ein Sprachwechsel ohne neuen Status sofort greift.
   */
  get optionalText(): string {
    return (this.optionalField('optional_txt') || '').trim();
  }

  /** Ohne Schema ("www.…") wäre der Link relativ zur Eventseite */
  get optionalLink(): string {
    const link = (this.optionalField('optional_link') || '').trim();
    return !link || /^[a-z][a-z0-9+.-]*:/i.test(link) ? link : `https://${link}`;
  }

  get optionalLinkText(): string {
    return (this.optionalField('optional_linkdesc') || '').trim() || this.optionalLink;
  }

  private optionalField(prefix: 'optional_txt' | 'optional_link' | 'optional_linkdesc'): string | undefined {
    const lang = this.activeLang();
    if (!this.eStatus || (lang !== 'de' && lang !== 'en' && lang !== 'nl')) return undefined;
    return this.eStatus[`${prefix}_${lang}`];
  }

  @HostListener('window:resize')
  onResize(): void {
    this.screenwidth = window.innerWidth;
  }

  ngOnDestroy(): void {
    this.statusSub?.unsubscribe();
  }
}
